import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getEbayCategoryList = createAsyncThunk(
  'general/getEbayCategoryList',
  async (params, { rejectWithValue }) => {
    try {
      const {
        data: { CategoryArray: { Category: category } }
      } = await authGet('/general/list/ebayCategories', { params });
      return category;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default getEbayCategoryList;
